import { createContext } from 'react'

export default createContext({
  menuCollapsed: false,
  setMenuCollapsed: () => {},
})
